import { Dashboard } from './pages/dashboard';

export const DashboardRoutes = [{ path: '/overview', component: Dashboard }];
